import React from "react";
import ChatMessages from "./ChatMessages/ChatMessages";
import SendMessages from "./SendMessages/SendMessages";
import CTE from "./Constants";
import AudioRecorder from "audio-recorder-polyfill";
import { VoiceRecorder } from "capacitor-voice-recorder";
import { isMobileView, isNativeMobile } from "frontend-lib/Utils/Mobile";

async function recordAudioForAndroidIos() {
    const audioPermission = await VoiceRecorder.requestAudioRecordingPermission();
    if (!audioPermission.value) throw new Error(`No audio permission`);
    return {
        start: VoiceRecorder.startRecording,
        stop: async () => {
            const recordedData = await VoiceRecorder.stopRecording();
            const binaryData = atob(recordedData.value.recordDataBase64);
            const uint8Array = new Uint8Array(binaryData.length);
            for (let i = 0; i < binaryData.length; i++) {
                uint8Array[i] = binaryData.charCodeAt(i);
            }
            return { audioChunks: [uint8Array], mimeType: recordedData.value.mimeType };
        },
    };
}

let timer;
class Chat extends React.Component {
    constructor(props) {
        super(props);
        this.sendUserMessage = this.sendUserMessage.bind(this);
        this.handleTextInput = this.handleTextInput.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
        this.detectKeypress = this.detectKeypress.bind(this);
        this.uploadAndSend = this.uploadAndSend.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.changeAudioRecordState = this.changeAudioRecordState.bind(this);
        this.startRecordingAudio = this.startRecordingAudio.bind(this);
        this.finishRecordingAudio = this.finishRecordingAudio.bind(this);
        this.vHeight = document.documentElement.clientHeight;
        this.wrapperRef = React.createRef();
        this.state = {
            token: "",
            textInput: "",
            messages: [],
            renderMessages: [],
            height: this.vHeight + "px",
            isConnected: true,
            customStyles: {},
            showLoadMore: false,
            audioRecordState: CTE.AUDIO_RECORD_STATES.DISABLED,
            recorder: {},
        };
    }

    /**
     * Handle the changes on the text input
     * @param {Object} event
     */
    handleTextInput(value) {
        this.setState({ textInput: value });
    }

    /**
     * Send the message of the user to the server
     * @param {String} msg
     */
    sendUserMessage() {
        if (
            this.props.textInput === "" ||
            this.props.textInput === undefined ||
            !this.props.textInput.replace(/\s/g, "").length
        ) {
            return false;
        }
        this.props.newMessageCb(this.state.textInput);
    }

    recordAudio = () => {
        if (isNativeMobile()) {
            return recordAudioForAndroidIos();
        } else {
            return new Promise((resolve, reject) => {
                navigator.mediaDevices
                    .getUserMedia({ audio: true })
                    .then((stream) => {
                        const mimeType = "audio/mpeg";
                        const mediaRecorder = new AudioRecorder(stream, { mimeType: mimeType });
                        const audioChunks = [];

                        mediaRecorder.addEventListener("dataavailable", (event) => {
                            audioChunks.push(event.data);
                        });

                        const start = () => {
                            mediaRecorder.start();
                        };

                        const stop = () => {
                            return new Promise((resolve) => {
                                mediaRecorder.addEventListener("stop", () => {
                                    resolve({ audioChunks: audioChunks, mimeType: mimeType });
                                });
                                this.stopStream(stream);
                                mediaRecorder.stop();
                            });
                        };

                        resolve({ start, stop });
                    })
                    .catch((err) => {
                        reject(err);
                        console.log(err);
                    });
            });
        }
    };

    stopStream(stream) {
        stream.getTracks().forEach((track) => track.stop());
    }

    changeAudioRecordState(state) {
        /*
        DISABLED: No está el boton o todavía no se toco
        BLOCKED: El browser no permite el acceso
        RECORDING: Arranco a grabar
        PENDING: Se pidió el permiso pero no se aceptó o bloqueó
        CANCEL: Salir de la interfaz de grabado por falta de acceso o cancelación del audio
        FINISH: Se terminó de grabar el audio, se proceso el archivo y está listo para enviar y volver a disabled
        */
        this.setState({ audioRecordState: state }, () => {
            switch (state) {
                case CTE.AUDIO_RECORD_STATES.PENDING:
                    this.startRecordingAudio();
                    break;
                case CTE.AUDIO_RECORD_STATES.CANCEL:
                    this.cancelRecordingAudio();
                    break;
                case CTE.AUDIO_RECORD_STATES.FINISH:
                    this.finishRecordingAudio();
                    break;
                default:
                    break;
            }
        });
    }

    async startRecordingAudio() {
        try {
            const recorder = await this.recordAudio();
            timer = setTimeout(() => {
                if (this.state.audioRecordState === CTE.AUDIO_RECORD_STATES.RECORDING) {
                    this.cancelRecordingAudio();
                }
            }, 600000);
            this.setState({ recorder: recorder }, () => {
                this.state.recorder.start();
                this.setState({ audioRecordState: CTE.AUDIO_RECORD_STATES.RECORDING });
            });
        } catch (err) {
            this.setState({ audioRecordState: CTE.AUDIO_RECORD_STATES.BLOCKED });
        }
    }

    async cancelRecordingAudio() {
        await this.state.recorder.stop();
        clearInterval(timer);
        this.setState({ audioRecordState: CTE.AUDIO_RECORD_STATES.DISABLED }, () => {
            this.setState({ recordAudio: null });
        });
    }

    extensionFromMimeType(mimeType) {
        if (mimeType === "audio/aac") {
            // Enters here if it's recorded from android/ios
            return ".m4a";
        } else {
            return ".mp3";
        }
    }

    async finishRecordingAudio() {
        const { audioChunks, mimeType } = await this.state.recorder.stop();
        clearInterval(timer);
        let name =
            Date.now() + Math.floor(Math.random() * 100) + this.extensionFromMimeType(mimeType);
        let audioBlob = new Blob(audioChunks, { type: mimeType });
        let file = new File([audioBlob], name, { type: mimeType });
        this.props.newMultimediaMessageCb(file);
        this.setState({ audioRecordState: CTE.AUDIO_RECORD_STATES.DISABLED }, () => {
            this.setState({ recordAudio: null });
        });
    }

    uploadAndSend(file, fileName, preview) {
        this.props.uploadFileCb(file, fileName, preview);
    }

    /**
     * Scroll to bottom the chat view
     */
    scrollToBottom() {
        this.messagesEnd.scrollIntoView();
    }

    /**
     * Takes the vertical height of the viewport
     * and saves it in the state
     */
    updateDimensions() {
        const vHeight = document.documentElement.clientHeight;
        this.setState({
            height: vHeight,
        });
    }

    detectKeypress(key) {
        if (key.keyCode === 13) {
            if (key.ctrlKey || isMobileView()) {
                return;
            }
            this.sendUserMessage();
        }
    }

    handleScroll() {
        if (this.wrapperRef.current.scrollTop < 10) {
            this.setState({ showLoadMore: true });
        } else {
            this.setState({ showLoadMore: false });
        }
    }

    componentDidMount() {
        window.addEventListener("keydown", this.detectKeypress, false);
        // AutoScroll when load new messages
        this.scrollToBottom();
        // On the web version the resizer is on to adjust the screen to the viewport
        if (this.props.isFullScreen) {
            // UI events
            window.addEventListener("resize", this.updateDimensions);
            // UI dimensions update
            this.updateDimensions();
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.messages.length !== this.props.messages.length &&
            this.props.scrollOnNewMessages
        ) {
            this.scrollToBottom();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.detectKeypress);
        window.removeEventListener("resize", this.updateDimensions);
    }

    render() {
        let fullHeight = {};
        let chatHeight = {};
        if (this.props.chatHeight) {
            chatHeight = {
                height: this.props.chatHeight,
            };
        }
        if (this.props.isFullScreen) {
            fullHeight = {
                minHeight: this.state.height,
                maxHeight: this.state.height,
            };
            if (window.innerWidth < 768) {
                chatHeight = {
                    minHeight: "90vh",
                    maxHeight: this.state.height + "px",
                };
            } else {
                chatHeight = {
                    minHeight: this.state.height - 60 + "px",
                    maxHeight: this.state.height - 60 + "px",
                };
            }
        }
        return (
            <div style={fullHeight} className="main-container">
                <style>{`
                    .chat-message-wrapper a,
                    .chat-optiwe a,
                    .opt-map-widget__text{
                        color: ${this.props.customStyles.bubbles.agentBubbleLink.color} !important;
                    }
                `}</style>
                <div
                    className="opt-chat-background"
                    style={this.props.customStyles.background}
                ></div>
                <div
                    ref={this.wrapperRef}
                    onScroll={this.handleScroll}
                    className="section-background"
                    style={{ ...chatHeight }}
                >
                    {this.props.paginator &&
                        this.props.paginator.hasNext &&
                        this.state.showLoadMore && (
                            <div className="load-more-chats">
                                <button
                                    className="load-more-chats-button"
                                    onClick={this.props.loadMoreCb}
                                >
                                    {this.props.loadMoreText}
                                </button>
                            </div>
                        )}
                    <ChatMessages
                        defaultAvatar={this.props.defaultAvatar}
                        customStyles={this.props.customStyles}
                        language={this.props.language}
                        messages={this.props.messages}
                        isFullScreen={this.props.isFullScreen}
                        interactionCb={this.props.interactionCb}
                        mapKey={this.props.mapKey}
                        selectFileCb={this.uploadAndSend}
                        currentUserType={this.props.currentUserType}
                        referencedClickCb={this.props.referencedClickCb}
                        missingReferencedMessageText={this.props.missingReferencedMessageText}
                    />
                    <div
                        className="scrollFix"
                        ref={(el) => {
                            this.messagesEnd = el;
                        }}
                    ></div>
                </div>
                <SendMessages
                    sendIcon={this.props.sendIcon}
                    customStyles={this.props.customStyles}
                    isFullScreen={this.props.isFullScreen}
                    isConnected={this.props.isConnected}
                    isEnabled={this.props.isEnabled}
                    inputPlaceholder={this.props.inputPlaceholder}
                    isLoading={this.props.isLoading}
                    textInput={this.props.textInput}
                    handleTextInputCb={this.props.handleTextInput}
                    openPopupCb={() => this.setState({ uploadModal: true })}
                    sendUserMessageCb={this.sendUserMessage}
                    newMultimediaMessageCb={this.props.newMultimediaMessageCb}
                    showAudioRecordButton={this.props.showAudioRecordButton}
                    audioRecordState={this.state.audioRecordState}
                    changeAudioRecordStateCb={this.changeAudioRecordState}
                    finishRecordingAudioCb={this.finishRecordingAudio}
                    enableSendMultimediaButton={this.props.enableSendMultimediaButton}
                    showProgress={this.props.isLoading}
                />
            </div>
        );
    }
}
export default Chat;
